import { Component, OnInit } from "@angular/core";
import { constants } from './../../utitlity/constant';
import { Helper } from './../../utitlity/helper';

@Component({
    selector: "ntb-error-page",
    template: `
    <div class="error-container">
    <div class="col-md-12" ng-if="errorMsg">
    <div class="ao-submission-third-title" [innerHTML]="errorMsg"></div>
    </div></div>
    `,
    styles: [require('./error-page.component.css')]
})

export class ErrorPageComponent implements OnInit {

    errorMsg: string = "";
    constructor() {

    }

    ngOnInit() {
        this.errorMsg = Helper.applicationObj.errorMsg;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/error-page/error-page.component.ts